//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
export var getFormFieldsInputHeight = function (theme) {
    return theme.v1.formFields.input.height;
};
export var getFormFieldsCheckboxHeight = function (theme) {
    return theme.v1.formFields.checkbox.height;
};
export var getFormFieldsSwitchHeight = function (theme) {
    return theme.v1.formFields.switch.height;
};
